export default "__VITE_ASSET__c6c40e4c__"